import React, { useState } from "react";
import { Modal, Form, Button, Typography, message } from "antd";
import IconConfirm from '../../../assets/images/confirm.png';
import Service from "./../../../utils/apiOpen";
import LyDoTuChoi from "./ly-do-tu-choi-duyet";

function XacNhanDuyetNgung(props) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const Suspension = async () => {
    setLoading(true);
    const dataForm = {
      "uid": props?.detail?.uid || undefined,
      "status": 'ngung_hoat_dong' || undefined,
    }
    await Service.openApiCall("PATCH", `/v1/affiliate/portal/product`, dataForm)
      .then((res) => {
        setLoading(false);
        let data = res?.data;
        if (data.success) {
          props.MessageSucces('Duyệt Ngừng Bán Sản Phẩm Thành Công.');
          props.getList();
          props.handleCancel();
        }
      })
      .catch((err) => {
        setLoading(false);
        if (err?.response) {
          message.error(err?.response?.data?.error?.statusCode + '|' + err?.response?.data?.message);
        }
      });
  };

  return (
    <Modal open={true} onOk={''} onCancel={props.handleCancel} closable={true} footer={null} centered width={380}>
      <div style={{ display: 'flex', justifyContent: 'center', textAlign: 'center', padding: '16px' }}>
        <img src={IconConfirm} alt="" style={{ width: '60px' }} />
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', textAlign: 'center', padding: '16px' }}>
        <Typography.Text style={{ fontSize: 15, fontWeight: 700, color: '#4b4b4b' }}>
          Bạn có chắc chắn duyệt ngừng bán sản <br />phẩm này?
        </Typography.Text>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 16 }}>
        <Button
          onClick={() => props.setOpenMD({ ...props.openMD, XacNhanDuyetNgung: false, LyDoTuChoi: true })}
          size='large'
          style={{ flex: 1, backgroundColor: '#F0F2F5', border: '1px solid #f0f2f5', color: '#4b4b4b', fontWeight: 500, marginRight: 8 }}>
          Từ chối
        </Button>
        <Button
          loading={loading}
          onClick={() => Suspension()}
          type="primary"
          size='large'
          style={{ flex: 1, backgroundColor: '#0B7CE4', border: 'none', color: '#fff', fontWeight: 500, marginLeft: 8 }}>
          Duyệt
        </Button>
      </div>
    </Modal>
  );
}

export default XacNhanDuyetNgung;
